import React from 'react';
import {
  Row,
  Col,
  Divider,
  Input,
  Select,
  Form,
  Typography,
  Button,
  Tag,
  Space,
  DatePicker,
  Table,
  Skeleton,
  Result
} from 'antd';
import {
  SearchOutlined
} from '@ant-design/icons';
import { convertTransactionType } from '../../utils/customFunctions'
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useLocation } from 'react-router-dom';
import UpdateReceivedTransferStatus from './components/UpdateReceivedTransferStatus';

const transactionTypeFilters = [
  { value: 'IN', label: 'รับเข้า' },
  // { value: 'OUT', label: 'ขายออก' },
  // { value: 'TRANSIN', label: 'โอนเข้า' },
  { value: 'TRANSOUT', label: 'โอนสินค้า' },
  // { value: 'ADJUSTIN', label: 'ปรับเพิ่ม' },
  // { value: 'ADJUSTOUT', label: 'ปรับลด' },
];
const transactionStatusFilters = [
  { value: 'CREATED', label: 'อยู่ระหว่างดำเนินงาน' },
  { value: 'COMPLETED', label: 'สำเร็จ' },
  { value: 'CANCLED', label: 'ยกเลิก' },
];

const columns = [
  {
    title: 'วันที่',
    dataIndex: 'shipment_date',
    key: 'shipment_date',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/transactions/${record._id}`}
        style={{
          width: "100%",
          // textAlign: 'left',
          background: 'none'
        }}>
        {dayjs(text).format('DD-MM-YYYY')}
      </Button>
  },
  {
    title: 'เลขที่เอกสาร',
    dataIndex: 'doc_no',
    key: 'doc_no',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/transactions/${record._id}`}
        style={{
          width: "100%",
          // textAlign: 'left',
          background: 'none'
        }}>
        {text}
      </Button>
  },
  {
    title: 'ประเภท',
    dataIndex: 'transaction_type',
    key: 'transaction_type',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/transactions/${record._id}`}
        style={{
          width: "100%",
          // textAlign: 'left',
          background: 'none'
        }}>
        {convertTransactionType(text)}
      </Button>,
    // filters: transactionTypeFilters.map(f => ({ text: f.label, value: f.value })),
    // onFilter: (value, record) => record?.transaction_type.indexOf(value) === 0,
  },
  {
    title: 'ผู้ดำเนินการ',
    dataIndex: 'employee',
    key: 'employee',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/transactions/${record._id}`}
        style={{
          width: "100%",
          // textAlign: 'left',
          background: 'none'
        }}>
        {text?.fname ?? "-"}
      </Button>
  },
  {
    title: 'สถานะ',
    dataIndex: 'transaction_status',
    key: 'transaction_status',
    width: '10%',
    // filters: transactionStatusFilters.map(f => ({ text: f.label, value: f.value })),
    // onFilter: (value, record) => record?.transaction_status.indexOf(value) === 0,
    render: (text, record) => {
      switch (text) {
        case 'COMPLETED': return <Tag color="success">สำเร็จ</Tag>
        case 'CANCLED': return <Tag color="error">ยกเลิก</Tag>
        default: return (
          <Space>
            <Tag color="processing">อยู่ระหว่างดำเนินงาน</Tag>
            <UpdateReceivedTransferStatus receivedData={record} />
          </Space>
        );
      }
    }
  },
  // {
  //   title: 'สถานะ',
  //   dataIndex: 'transaction_status',
  //   key: 'transaction_status',
  //   render: (text, record) => <UpdateReceivedTransferStatus receivedData={record} />
  // },
]

function List() {
  const [form] = Form.useForm();
  const redirect = useNavigate();
  const location = useLocation();
  const page = new URLSearchParams(location.search).get('page');
  const page_size = new URLSearchParams(location.search).get('page_size');

  const { isError, isLoading, data, error } = useQuery({
    queryKey: [`/api/transaction/getWarehouseActivities?page=${page}&page_size=${page_size}`],
  })

  const totalActivitieQuery = useQuery({
    queryKey: [`/api/transaction/getTotalWarehouseActivities`],
  })


  if (isLoading || totalActivitieQuery.isLoading) {
    return <Skeleton active />
  }

  if (isError || totalActivitieQuery.isError) {
    return <Result status="error" title={error.message || totalActivitieQuery.error.message} />
  };

  const onSearch = e => {
    form
      .validateFields()
      .then(values => {
        // console.log(values);
        let searchText = `/admin/searchTransaction?&`;
        if (values.date) searchText += `start_date=${dayjs(values.date[0]).toISOString()}&end_date=${dayjs(values.date[1]).toISOString()}&`;
        if (values.transaction_type) searchText += `transaction_type=${values.transaction_type}&`;
        if (values.transaction_status) searchText += `transaction_status=${values.transaction_status}&`;
        if (values.q) searchText += `q=${values.q}&`;
        redirect(searchText);
      })
      .catch(err => {
        console.log(err)
      })
  }

  const onPageChange = (pg, pz) => {

    redirect(`/admin/transactions?page=${pg}&page_size=${pz}`);

};

  // console.log('data :', data);
  // console.log('total :', totalActivitieQuery.data);

  return (
    <div style={{
      background: '#fff',
    }}>

      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            รายการดำเนินงาน
          </Typography.Title>
        </Col>
        <Col xs={24} >
          {/* <Row justify="end">
            <Col>
              <AddFormModal />
            </Col>
          </Row> */}
        </Col>
        <Divider />
        <Col xs={24} >
          <Row justify='space-between' gutter={[0, 16]}>
            <Col xs={24}>
              <Row justify='space-between' gutter={[0, 16]}>
                <Col xs={24}>
                  <Form
                    form={form}
                    name="searchTransaction"
                    layout="vertical"
                  >
                    <Row gutter={[8, 0]}>
                      <Col xs={24} md={8}>
                        <Form.Item name="date" label="" >
                          <DatePicker.RangePicker
                            placeholder={["วันเริ่มต้น", "วันสิ้นสุด"]}
                            style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8}>
                        <Form.Item name="transaction_type" label="">
                          <Select
                            placeholder="เลือกประเภท"
                            showSearch
                            optionFilterProp="children"
                            allowClear
                          >
                            {transactionTypeFilters.map(t => <Select.Option key={t.value} value={t.value}>
                              {t.label}
                            </Select.Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8}>
                        <Form.Item name="transaction_status" label="">
                          <Select
                            placeholder="เลือกสถานะ"
                            showSearch
                            optionFilterProp="children"
                            allowClear
                          >
                            {transactionStatusFilters.map(t => <Select.Option key={t.value} value={t.value}>
                              {t.label}
                            </Select.Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24}>
                        <Row gutter={[8, 0]}>
                          <Col xs={24} sm={12} >
                            <Form.Item
                              label=""
                              name="q"
                            >
                              <Input placeholder="ค้นหา เลขที่เอกสาร ชื่อบริษัท หมายเลขโทรศัพท์" allowClear />
                            </Form.Item>
                          </Col>
                          <Col >
                            <Button
                              type='primary'
                              icon={<SearchOutlined />}
                              onClick={onSearch}
                              style={{ width: '100%' }}
                            >ค้นหา</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </Col>
            <Col xs={24}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={data}
                scroll={{
                  x: 1200,
                }}
                pagination={{
                  current: parseInt(page),
                  pageSize: parseInt(page_size),
                  total: totalActivitieQuery.data,
                  onChange: onPageChange,
                  showSizeChanger: true
              }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default List